import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './AuthContext';
import { ThemeProvider } from './components/ThemeProvider';
import { EmbedAgentPageContent } from './components/EmbedAgentPage';
import EmbedLiveAvatarPage from './components/EmbedLiveAvatarPage';
import EmbedLiveAvatarMinimalPage from './components/EmbedLiveAvatarMinimalPage';
import EmbedLiveAvatarProductsPage from './components/EmbedLiveAvatarProductsPage';
import EmbedLiveAvatarProductsFullscreenPage from './components/EmbedLiveAvatarProductsFullscreenPage';
import EmbedAvatarPanelPage from './components/EmbedAvatarPanelPage';
import AvatarPanelV2 from './components/AvatarPanelV2';
import ChatEmbedPage from './components/ChatEmbedPage';
import { VoiceCallWidgetPage } from './components/VoiceCallWidget';
import { UnifiedEmbedPage } from './components/UnifiedEmbedWidget';
import { ComboWidgetV2Page } from './components/ComboWidgetV2';
import { LogoVoiceEmbedPage } from './components/LogoVoiceEmbedWidget';
import { CobrowseWidgetPage } from './components/CobrowseWidget';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
const embedMatch = window.location.pathname.match(/^\/embed\/agent\/([^/]+)/);
const voiceWidgetMatch = window.location.pathname.match(/^\/embed\/voice-widget\/([^/]+)/);
const comboWidgetMatch = window.location.pathname.match(/^\/embed\/combo-widget\/([^/]+)/);
const comboWidgetV2Match = window.location.pathname.match(/^\/embed\/combo-widget-v2\/([^/]+)/);
const logoVoiceWidgetMatch = window.location.pathname.match(/^\/embed\/logo-voice-widget\/([^/]+)/);
const chatEmbedMatch = window.location.pathname.match(/^\/embed\/chat\/([^/]+)/);
const liveavatarEmbedMatch = window.location.pathname.match(/^\/embed\/liveavatar\/([^/]+)/);
const liveavatarMinimalEmbedMatch = window.location.pathname.match(/^\/embed\/liveavatar-minimal\/([^/]+)/);
const liveavatarProductsFullscreenEmbedMatch = window.location.pathname.match(/^\/embed\/liveavatar-products-fullscreen\/([^/]+)/);
const liveavatarProductsEmbedMatch = window.location.pathname.match(/^\/embed\/liveavatar-products\/([^/]+)/);
const avatarPanelEmbedMatch = window.location.pathname.match(/^\/embed\/avatar-panel\/([^/]+)/);
const avatarPanelV2EmbedMatch = window.location.pathname.match(/^\/embed\/avatar-panel-v2\/([^/]+)/);
const cobrowseEmbedMatch = window.location.pathname.match(/^\/embed\/cobrowse\/([^/]+)/);

if (cobrowseEmbedMatch) {
  // Co-browse widget: voice call that can guide the host page (cobrowse-widget.js)
  root.render(
    <React.StrictMode>
      <CobrowseWidgetPage agentId={cobrowseEmbedMatch[1]} />
    </React.StrictMode>
  );
} else if (avatarPanelV2EmbedMatch) {
  // Interactive Avatar Panel V2. No ThemeProvider: the panel derives its whole
  // palette from the agent's saved config so it matches the client's site, not
  // the admin app's light/dark preference.
  root.render(
    <React.StrictMode>
      <AvatarPanelV2 agentId={avatarPanelV2EmbedMatch[1]} />
    </React.StrictMode>
  );
} else if (avatarPanelEmbedMatch) {
  const forcedAgentId = avatarPanelEmbedMatch[1];
  root.render(
    <React.StrictMode>
      <ThemeProvider defaultTheme="dark" storageKey="braincx-ui-theme">
        <EmbedAvatarPanelPage agentId={forcedAgentId} />
      </ThemeProvider>
    </React.StrictMode>
  );
} else if (liveavatarProductsFullscreenEmbedMatch) {
  const forcedAgentId = liveavatarProductsFullscreenEmbedMatch[1];
  root.render(
    <React.StrictMode>
      <ThemeProvider defaultTheme="dark" storageKey="braincx-ui-theme">
        <EmbedLiveAvatarProductsFullscreenPage agentId={forcedAgentId} />
      </ThemeProvider>
    </React.StrictMode>
  );
} else if (liveavatarProductsEmbedMatch) {
  const forcedAgentId = liveavatarProductsEmbedMatch[1];
  root.render(
    <React.StrictMode>
      <ThemeProvider defaultTheme="dark" storageKey="braincx-ui-theme">
        <EmbedLiveAvatarProductsPage agentId={forcedAgentId} />
      </ThemeProvider>
    </React.StrictMode>
  );
} else if (liveavatarMinimalEmbedMatch) {
  const forcedAgentId = liveavatarMinimalEmbedMatch[1];
  root.render(
    <React.StrictMode>
      <ThemeProvider defaultTheme="dark" storageKey="braincx-ui-theme">
        <EmbedLiveAvatarMinimalPage agentId={forcedAgentId} />
      </ThemeProvider>
    </React.StrictMode>
  );
} else if (liveavatarEmbedMatch) {
  const forcedAgentId = liveavatarEmbedMatch[1];
  root.render(
    <React.StrictMode>
      <ThemeProvider defaultTheme="dark" storageKey="braincx-ui-theme">
        <EmbedLiveAvatarPage agentId={forcedAgentId} />
      </ThemeProvider>
    </React.StrictMode>
  );
} else if (logoVoiceWidgetMatch) {
  const forcedAgentId = logoVoiceWidgetMatch[1];
  root.render(
    <React.StrictMode>
      <LogoVoiceEmbedPage agentId={forcedAgentId} />
    </React.StrictMode>
  );
} else if (comboWidgetV2Match) {
  const forcedAgentId = comboWidgetV2Match[1];
  root.render(
    <React.StrictMode>
      <ComboWidgetV2Page agentId={forcedAgentId} />
    </React.StrictMode>
  );
} else if (comboWidgetMatch) {
  const forcedAgentId = comboWidgetMatch[1];
  root.render(
    <React.StrictMode>
      <UnifiedEmbedPage agentId={forcedAgentId} />
    </React.StrictMode>
  );
} else if (voiceWidgetMatch) {
  const forcedAgentId = voiceWidgetMatch[1];
  root.render(
    <React.StrictMode>
      <VoiceCallWidgetPage agentId={forcedAgentId} />
    </React.StrictMode>
  );
} else if (chatEmbedMatch) {
  const forcedAgentId = chatEmbedMatch[1];
  root.render(
    <React.StrictMode>
      <ThemeProvider defaultTheme="dark" storageKey="braincx-ui-theme">
        <ChatEmbedPage />
      </ThemeProvider>
    </React.StrictMode>
  );
} else if (embedMatch) {
  const forcedAgentId = embedMatch[1];
  root.render(
    <React.StrictMode>
      <ThemeProvider defaultTheme="dark" storageKey="braincx-ui-theme">
        <AuthProvider>
          <EmbedAgentPageContent agentId={forcedAgentId} />
        </AuthProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}